<template>
  <div class="left-bar bar">

    <div
      v-if="!isPureVersion"
      class="like item"
      @click="handleClickLike"
    >
      <img
        v-if="!isLikeActive"
        src="@/assets/icon/like.png"
        alt=""
      >
      <img
        v-else
        src="@/assets//icon/like-active.png"
        alt=""
      >
      <div>{{countObj.pointupCount}}</div>
    </div>
    <!-- <div
      v-if="$store.state.userInfo.commentStatus"
      class="comment item"
      @click="handleClickComment"
    >
      <img
        src="@/assets/icon/comment.png"
        alt=""
      >
      <div>{{countObj.commentCount}}</div>
    </div> -->
    <div
      class="share item"
      v-if="isShowShare"
      @click="handleClickShare"
    >
      <img
        src="@/assets/icon/share.png"
        alt=""
      >
      <div>{{countObj.forwardCount}}</div>
    </div>
    <div :class="['avatar', $store.state.userInfo.liveState === 1 ?'live item' : 'item']">
      <div
        class="live-icon"
        v-if="$store.state.userInfo.liveState === 1"
      >
        <img
          src="@/assets/icon/live-icon.png"
          alt=""
        >
      </div>
      <van-image
        class="user-avatar"
        round
        :src="$store.state.userInfo.photoUrl ? $store.state.userInfo.photoUrl
        : $store.state.userInfo.avatarUrl"
        @click="handleClickAvatar"
      >
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
      <div class="user-name">
        <span>@{{$store.state.userInfo.nickName}}</span>
      </div>
      <div
        v-if="!isFollow && type !== 'app'"
        class="add-attention"
        @click="handleClickAdd"
      >+</div>
    </div>
    <div
      class="memo"
      v-if="memo"
    >
      <div v-clampy="3">
        {{memo}}
      </div>
    </div>

  </div>
</template>
<script>
import { throttle } from 'lodash';

export default {
  data() {
    return {
      userInfo: this.$store.state.userInfo,
    };
  },
  computed: {
    isShowShare() {
      if (this.$store.state.appRoute) {
        return this.$UA.isUserApp;
      }
      return true;
    },
  },
  props: {
    isPureVersion: {
      type: Boolean,
      default: false,
    },
    isLikeActive: {
      type: Boolean,
      default: () => false,
    },
    isFollow: {
      type: Boolean,
      default: () => false,
    },
    countObj: {
      type: Object,
      default: () => {},
    },
    memo: String,
    type: String,
  },
  methods: {
    // eslint-disable-next-line func-names
    handleClickLike: (() => throttle(function () {
      this.$emit('clickLike');
    }, 500))(),
    // handleClickComment() {
    //   this.$emit('clickComment');
    // },
    handleClickShare() {
      this.$emit('clickShare');
    },
    handleClickAdd() {
      this.$emit('clickAdd');
    },
    handleClickAvatar() {
      this.$emit('clickAvatar');
    },
  },
};
</script>
<style lang="less" scoped>
.left-bar {
  left: 20px;
  bottom: 60px;
    .avatar {
      position: relative;
      margin-bottom: 60px;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
        border: 1px solid #fff;
      }
      .add-attention {
        position: absolute;
        width: 30px;
        height: 15px;
        background: linear-gradient(180deg, rgba(255, 81, 181, 1) 0%, rgba(255, 0, 0, 1) 100%);
        border-radius: 8px;
        text-align: center;
        line-height: 15px;
        left: 50%;
        transform: translateX(-50%);
        bottom: -7px;
        text-shadow: none;
        font-size: 16px;
      }
      .user-name {
        position: absolute;
        font-size: 16px;
        margin-left: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 200px;
        left: 35px;
        text-align: left;
        margin-top: 0;
      }
    }
    .live {
      border: 1px solid rgba(255,0,0,1);
      padding: 2px;
      border-radius: 50%;
      width: 46px;
      height: 46px;
      .live-icon{
        position: absolute;
        width: 24px;
        margin-top: 0;
        top: 0;
        left: 50%;
        z-index: 1;
        transform: translateX(-50%);
        img{
          width: 100%;
        }
      }
      .van-image {
        margin: 0;
      }
    }
    .share {
      img {
        width: 40px;
      }
    }
    .item {
      margin-top: 18px;
      text-align: center;
      font-size: 12px;
      img {
        width: 40px;
      }
      div {
        margin-top: 5px;
      }
    }
    .memo {
      position: absolute;
      font-size: 14px;
      width: calc(100vw - 40px);
      bottom: 0;
      line-height: 18px;
    }
}
</style>
